
import { Link } from 'react-router-dom';

const BangladeshFooter = () => {
  return (
    <div className="w-full text-center py-2 border-t border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
      <div className="flex flex-col md:flex-row justify-between items-center gap-2 px-4">
        <Link 
          to="/" 
          className="text-green-600 hover:text-green-700 text-sm font-medium underline hover:no-underline transition-all duration-300"
        >
          Go to full website
        </Link>
        <p className="text-gray-600 text-sm">
          © 2025 NEXX TELECOM LLC. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default BangladeshFooter;
